import React, { ReactElement } from 'react';
import { Card, Typography } from '@material-ui/core';
import { Game } from '../../../../api/games/model';
import { TypographyEllipsis } from '../../../../components/output/TypographyEllipsis';

type ResultListEntryProps = {
  finishedGame: Game;
};

export const ResultListEntry = ({ finishedGame }: ResultListEntryProps): ReactElement => {
  return (
    <Card>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          padding: '8px',
          paddingRight: '16px',
          gap: 4,
          background: '#f5f5f5',
        }}
      >
        <div>
          <Typography variant="body2" color="textSecondary" align="left">
            {finishedGame.gameResultTimestamp.toLocaleString()}
          </Typography>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-end',
          }}
        >
          <Typography component="div" variant="body1">
            <TypographyEllipsis component="span" bold={finishedGame.challenger.id === finishedGame.winner.id}>
              {finishedGame.challenger.name}
            </TypographyEllipsis>{' '}
            -{' '}
            <TypographyEllipsis component="span" bold={finishedGame.defender.id === finishedGame.winner.id}>
              {finishedGame.defender.name}
            </TypographyEllipsis>
          </Typography>

          <Typography component="div" variant="body1" style={{ fontWeight: 'bold', fontSize: '20px' }}>
            {finishedGame.result || '\u00A0'}
          </Typography>
        </div>
      </div>
    </Card>
  );
};
